module.exports = __webpack_public_path__ + "static/media/lumbering29.f78ccd25.jpg";